// extracted by mini-css-extract-plugin
export default {"List_items":"zSvUZeSrpaZNusxUtfAe","List_item":"tsrKyDhtPdbpFPasYB_n"};